// extracted by mini-css-extract-plugin
export var assigneeBadge = "_k5-0";
export var assigneeDetails = "_k5-1";
export var assigneeInfo = "_k5-2";
export var dropdownContainer = "_k5-4";
export var dropdownImage = "_k5-5";
export var editAssigneeInfo = "_k5-3";
export var editAssigneeModalContainer = "_k5-6";
export var hidden = "_k5-8";
export var input = "_k5-7";